export default __webpack_public_path__ + "static/media/welComeAudio.42893472.mp3";